import { Trans } from "@lingui/macro";
import React from "react";
import styled from "styled-components";
import { CancellationPolicyId } from "~/applications/Checkout/Domain/CancellationPolicyId";
import { AccommodationOffer } from "~/applications/OfferSearch/Domain/AccommodationOffer";
import { TrackedButton } from "~/components/Tracking/GoogleTagManager";
import { Button } from "~/guidelines/Button";
import { usePriceFormatter } from "~/guidelines/usePriceFormatter";

const ButtonContainer = styled.div`
  min-height: 48px;
`;

type BookingButtonProps = {
  accommodationOffer: AccommodationOffer | undefined | null;
  selectedCancellationPolicyId: CancellationPolicyId | undefined;
  onBook?: () => void;
  onNewSearch: () => void;
};

const BookingButton = ({
  accommodationOffer,
  selectedCancellationPolicyId,
  onBook,
  onNewSearch,
}: BookingButtonProps) => {
  const { marketingPriceFormatter } = usePriceFormatter();

  if (selectedCancellationPolicyId === undefined) {
    return (
      <ButtonContainer>
        <Button onPress={onNewSearch} size="large">
          <Trans>Check availability</Trans>
        </Button>
      </ButtonContainer>
    );
  }

  if (accommodationOffer === undefined) {
    return <ButtonContainer />;
  }

  if (accommodationOffer === null || accommodationOffer.isSoldOut) {
    return (
      <ButtonContainer>
        <Button onPress={onNewSearch}>
          <Trans>Do a new search</Trans>
        </Button>
      </ButtonContainer>
    );
  }

  return (
    <ButtonContainer>
      <TrackedButton
        onPress={onBook}
        size="large"
        ctaName="Book for XXX/night"
        ctaLocation="hotel_page"
      >
        <Trans>
          Book for{" "}
          {marketingPriceFormatter(accommodationOffer.basePrices.pricePerNight)}
          /night
        </Trans>
      </TrackedButton>
    </ButtonContainer>
  );
};

export default BookingButton;
